/**
 * ViewJobsPage — standalone page for /viewJobs routes.
 * Mirrors Flutter routing where /viewJobs navigates to WebProfile
 * with profileTabIndex=1.
 *
 * This page renders the Profile layout with the View Jobs tab active.
 */
import { PageLayout } from '@/components/layout/PageLayout';
import { ViewJobsSection } from '@/features/profile/components/ViewJobsSection';

export function ViewJobsPage() {
  return (
    <PageLayout>
      <ViewJobsSection />
    </PageLayout>
  );
}
